import { render, staticRenderFns } from "./SalesReturnItem.vue?vue&type=template&id=6a3665f4&"
import script from "./SalesReturnItem.vue?vue&type=script&lang=js&"
export * from "./SalesReturnItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SalesReturnItem.vue"
export default component.exports